import React from "react";
import "./LineChart.scss";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const LineChart = ({ data, currency }) => {
  
  const options = {
    responsive: true,
    //   maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return currency ? `${currency}${Number(value).toFixed(2)}` : value;
          },
        },
      },
    },
    scales: {
      y: {
        type: "linear",
        display: true,
        position: "left",
        min: 0,
        //   max: 40,
        ticks: {
          // stepSize: 5,
          callback: function (value, index, values) {
            if (index % 2 === 0) {
              if(currency){
                return `${currency}` + value.toFixed(2);
              }else{
                return value;
              }
            } else {
              return "";
            }
          },
          color: "#b0b0b0",
        },
        grid: {
          drawBorder: false,
          color: "#e0e0e0",
        },
      },
      x: {
        display: true,
        ticks: {
          autoSkip: true,
          maxTicksLimit: 4,
          minRotation: 0,
          maxRotation: 0,
          color: "#b0b0b0",
        },
        grid: {
          drawOnChartArea: false,
        },
      },
    },
    elements: {
      point: {
        radius: function (context) {
          const index = context.dataIndex;
          const dataset = context.dataset;
          return index === dataset.data.length - 1 ? 3 : 0;
        },
      },
      line: {
        borderWidth: 2,
        fill: false,
      },
    },
  };
  return <Line options={options} data={data} />;
};

export default LineChart;
